import React, {Component} from 'react'

import AuthBase from '../components/AuthBase'
import AuthButton from '../components/AuthButton'
import {alertActions, sourceActions} from "../_actions";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import AuthError from "../components/AuthError";
import {Header} from "../components/Header";
import {AnimatedLoader, Container, IsVerifying, StyledMedia} from "../styles/CommonStyler"
import Footer from "../components/Footer";
import {alertActionTypes} from "../_constants";
import {isMobileOnly} from "react-device-detect";
import sv from "../styles/styles";
import {__isAvailable, __isKeyAvailable} from "../_helpers";
import {DropzoneArea} from 'material-ui-dropzone';
import styled from "@emotion/styled";
import {withStyles} from "@material-ui/core";

// STYLE ##########################################################

const uploaderStyle = {
    dropZoneWithFileRoot: {
        minHeight: '150px',
        opacity: '.5',
    },
    progressFileRoot: {
        cursor: 'default !important',
    },
    chipRoot: {
        display: 'flex',
        marginTop: '10px',
        height: '40px',
    },
};

const ButtonContainer = styled(`div`)`
    ${sv.flexCenter}
    margin-top: 10px;
`;

const DropZoneContainer = styled(`div`)`
    margin: 15px;
`;

const SelectFileButton = styled(AuthButton)`
    position: relative;
    width: 60%;
    margin: 0 20%;
    bottom: 80px;
    pointer-events: none;
`;

// COMPONENT ##########################################################

class OrderGistUpload extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
    }

    state = {
        file: null,
    };

    componentDidMount() {
        const {uploads} = this.props;
        if(__isAvailable(uploads)) {
            this.props.resetUploads();  // cleanup existing information on load
        }
    }

    handleChange(files) {
        let file = null;
        if(files.length > 0) {
            file = files[0];
        }
        this.setState({file: file});
        this.props.clearAlert();
    };

    handleVerify(e) {
        if(this.state.file) {
            this.uploadFile(this.state.file);
        }
    }

    uploadFile(data) {
        this.props.uploadAndValidate(data);
    }

    isFileSelected() {
        return __isAvailable(this.state.file);
    }

    isInProgress() {
        return this.isInitializing() || this.isUploading() || this.isValidating();
    }

    getProgressText() {
        let progressText = "";
        const {t} = this.props;

        if(this.isInitializing()) {
            progressText = t('Initializing');
        } else if(this.isUploading()) {
            progressText = t('Uploading');
        } else if(this.isValidating()) {
            progressText = t("Validating");
        }
        return progressText;
    }

    isInitializing() {
        const {uploads} = this.props;
        return __isKeyAvailable(uploads, "packet") && uploads.packet.isLoading;
    }

    isUploading() {
        const {uploads} = this.props;
        return __isKeyAvailable(uploads, "deliverable") && uploads.deliverable.isUploading;
    }

    hasUploaded() {
        const {uploads} = this.props;
        return __isKeyAvailable(uploads, "deliverable") && uploads.deliverable.isUploaded;
    }

    isValidating() {
        const {order} = this.props;
        return this.hasUploaded() && order.isVerifying;
    }

    render() {
        const {t, alert, classes} = this.props;

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header/>

                    <AuthBase title={t('Order a Gist.')}>
                        <>
                            {alert.type === alertActionTypes.ERROR &&
                                <AuthError error={alert.message.errorMsg} />
                            }

                            <DropZoneContainer>
                                <DropzoneArea
                                    dropzoneProps={ { disabled: this.isInProgress()} }
                                    acceptedFiles={[        // allowed type
                                        'audio/*',          // audio
                                        'video/*',          // video
                                        'application/pdf',  // pdf
                                    ]}
                                    filesLimit={1}                              // limit file to 1
                                    maxFileSize={10 * 1000 * 1000000}           // limit to 10 GB
                                    onChange={this.handleChange.bind(this)}
                                    dropzoneText={t('Drag and drop media files to upload')}
                                    showPreviewsInDropzone={false}
                                    showPreviews={true}                         // preview is placed below the drop-zone
                                    previewText={''}                            // no preview heading
                                    useChipsForPreview={true}                   // preview in the form of chips
                                    previewChipProps={{                         // adjust chip properties
                                        color: 'primary',
                                        classes: {
                                            root: classes.chipRoot,
                                        },
                                        disabled: this.isInProgress(),
                                    }}
                                    classes={{
                                        root: `${(this.isFileSelected()) ? classes.dropZoneWithFileRoot : ''} ${this.isInProgress()  ? classes.progressFileRoot :''}`,
                                    }}
                                    showAlerts={['error']}                      // show alerts on error only
                                />
                                {!this.state.file && <SelectFileButton>{t('Select File')}</SelectFileButton>}
                            </DropZoneContainer>

                            <ButtonContainer>
                                {/* Show Upload button only before upload process begins */}
                                { !this.isInProgress() &&
                                <AuthButton disabled={!this.isFileSelected()} onClick={this.handleVerify}>{t('Upload and Validate')}</AuthButton>
                                }

                                {/* Show feedback loader with appropriate text */}
                                { this.isInProgress() &&
                                <IsVerifying>
                                    <h3>{ this.getProgressText() }</h3>
                                    <AnimatedLoader color={sv.colors.cta}/>
                                </IsVerifying>
                                }
                            </ButtonContainer>

                        </>
                    </AuthBase>
                    <Footer/>
                </Container>
            </StyledMedia>
        )
    }

}

function mapStateToProps(state) {
    const {alert, uploads, order} = state;
    return {
        alert, uploads, order
    };
}

function mapDispatchToProps(dispatch) {
    return {
        uploadAndValidate       : (data)    => dispatch(sourceActions.uploadAndValidate(data)),
        resetUploads            : ()        => dispatch(sourceActions.resetUploads()),
        dispatchEmptyFieldError : (msg)     => dispatch(alertActions.error(msg)),
        clearAlert              : ()        => dispatch(alertActions.clear()),
    };
}

const connectedUpload = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderGistUpload));
const styledConnectedUpload = withStyles(uploaderStyle)(connectedUpload);
export {styledConnectedUpload as OrderGistUpload};